import React from "react";
import "./mapComponent.less";
import "../list.less";

const ListMapProfileButton = ({ profile, profileSelection, handleClick, index }) => {
   const isButtonSelected = () => {
      if (
         (!profileSelection?.selectedProfile && index === 0) ||
         (profile && profileSelection?.selectedProfile?.id === profile.id)
      ) {
         return true;
      } else {
         return false;
      }
   };
   return (
      <div
         onClick={() => handleClick()}
         className={isButtonSelected() ? "single-profile bottom-map-list-header" : "single-profile"}
      >
         {profile.name}
      </div>
   );
};

export default ListMapProfileButton;
